import React from 'react'
import "./home.css"
import HeroImage from "../assets/banner_img.png"
import banner_img from "../assets/search-icon.png"
import CardImage from "../assets/card_one.png"
import CardImageTwo from "../assets/card_two.png"
import CardImageThree from "../assets/card_three.png" 
import Facility_img from "../assets/facility_img.png" 
import Car_Icon from "../assets/car_icon.png" 
import Location from "../assets/location.png" 
import EggIcon from "../assets/egg_icon.png" 
import CupIcon from "../assets/cup_icon.png"
import BellkIcon from "../assets/bell_icon.png" 
import WifiIcon from "../assets/wifi_icon.png" 
import SwimmingIcon from "../assets/swimming.png"
import LocationImg from "../assets/location_img.png"
import calander_icon from "../assets/calander_icon.png"
import user_icon from "../assets/user_icon.png"

export default function Home() {
  return (
    <>
    <div className='hero_outer'>
      <div className='container'>
        <div className='hero_outer_bg_img'>
        <div className='row d_flex'>
            <div className='book_perfect'>
            <h2>Book Perfect <span>Stay For Our Vacation</span></h2>
            <p>Experience the ultimate getaway with our seamless booking process. At Perfect Stay, we ensure every detail is taken care of, from luxurious accommodations to personalized services. Book with us and indulge in a vacation tailored to your desires. Your perfect stay awaits – all you need to do is arrive and relax.</p>
            <a className='book_btn'>Book Your Stay</a>

            </div>
            <div className='hero_outer_img'>
                <img src={HeroImage}/>
            </div>
        </div>
        </div>

        <div className='banner_section'>
      <div className='container'>
        <div className='banner_slide'>
            <div className='banner_content'>
           <div className='banner_box'>
           <img src={LocationImg}/>
            <div className='banner_box_heading'>
                <h6>Location</h6>
                <p>Bangladesh</p>
            </div>
           </div>

           <div className='banner_box'>
           <img src={calander_icon}/>
            <div className='banner_box_heading'>
                <h6>Check In</h6>
                <p>2 March 2025</p>
            </div>
           </div>
           <div className='banner_box'>
           <img src={calander_icon}/>
            <div className='banner_box_heading'>
                <h6>Check Out </h6>
                <p>19 April 2025</p>
            </div>
           </div>
           <div className='banner_box'>
           <img src={user_icon}/>
            <div className='banner_box_heading'>
                <h6>Rooms for</h6>
                <p>2 Rooms, 4 Guests</p>
            </div>
           </div>
           </div>
           <div className="banner_search">
           <img src={banner_img}/>
            <h5>Search</h5>
            </div>
        </div>
      </div>
      </div>

      <div className='home-card-section'>
        <div className='home-card-title'>
            <h2>In the Heart of the South Pacific, <span>Outstanding Views</span></h2>
            <p>Discover the enchanting beauty of the South Pacific, where breathtaking views greet you at every turn. Nestled amidst lush landscapes and crystal-clear waters, our resort offers a serene escape from the everyday. Wake up to the sight of vibrant sunrises over the ocean and unwind with spectacular sunsets. Embrace the tranquility and natural splendor that make this destination truly extraordinary.</p>
        </div>

        <div className='card_images'>
            <div className='card_img'>
            <img src={CardImage}/>
            </div>
            <div className='card_img'>
            <img src={CardImageTwo}/>
            </div>
            <div className='card_img'>
            <img src={CardImageThree}/>
            </div>
        </div>

      </div>
      </div>
      </div>

      <section className='home_facility'>
        <div className='container'>
            <div className='home-facility_section'>
                <div className='facility_content'>
                    <span>Best Summer Offers</span>
                    <h4>Check the Promotions</h4>
                    <p>Take advantage of our unbeatable summer offers and make the most of your vacation. Enjoy exclusive discounts on luxurious rooms, exciting activities, and gourmet dining. From family packages to romantic getaways, we have promotions tailored to suit every traveler. Check out our special deals and start planning your perfect summer escape today.</p>

                </div>
                <div className='facility_image'>
                <img src={Facility_img}/>
                </div>
                <div className='facility_price'>
                    <div className='facility_section_thrd'>
                    <div className='facility_title'>
                        <p>One week</p>
                        <h5>Small Sea Room</h5>
                    </div>
                    <div className='section_thrd_content'>
                        <h6>$<span>40</span></h6>
                    </div>
                    </div>
                    <div className='facility_section_thrd'>
                    <div className='facility_title'>
                        <p>One week</p>
                        <h5>Small Sea Room</h5>
                    </div>
                    <div className='section_thrd_content'>
                        <h6>$<span>40</span></h6>
                    </div>
                    </div>
                    <div className='facility_section_thrd'>
                    <div className='facility_title'>
                        <p>One week</p>
                        <h5>Small Sea Room</h5>
                    </div>
                    <div className='section_thrd_content'>
                        <h6>$<span>40</span></h6>
                    </div>
                    </div>
                    
                </div>
            </div>
        </div>
      </section>

      <section className='home-location'>
        <div className='container'>
            <div className='comfortable_stay'>
                <div className='location_img'>
                <img src={Location}/>
                </div>
                <div className='dark_glossy_card_sec'>
                    <h2>All the Essentials for a Cozy and <span>Comfortable Stay</span></h2>
                    <div className='facility_point'>
                        <div className='location_sec'>
                        <img src={Car_Icon}/>
                        <div className='location_content'>
                            <h5>Airport Pick-up Service</h5>
                            <p>Enjoy hassle-free arrival with our reliable airport pick-up service, ensuring a smooth start to your stay.</p>
                        </div>
                        </div>
                        <div className='location_sec'>
                        <img src={EggIcon}/>
                        <div className='location_content'>
                            <h5>Housekeeper Services</h5>
                            <p>Experience effortless cleanliness with our dedicated housekeeping services, ensuring a tidy and organized space.</p>
                        </div>
                        </div>
                        <div className='location_sec'>
                        <img src={CupIcon}/>
                        <div className='location_content'>
                            <h5>Wifi & Internet</h5>
                            <p>Stay connected throughout your visit with high-speed WiFi and reliable internet access available in all areas.</p>
                        </div>
                        </div>
                        <div className='location_sec'>
                        <img src={BellkIcon}/>
                        <div className='location_content'>
                            <h5>Laundry Services</h5>
                            <p>Stay fresh and clean with our convenient laundry services, available to keep your clothes in pristine condition.</p>
                        </div>
                        </div>
                        <div className='location_sec'>
                        <img src={WifiIcon}/>
                        <div className='location_content'>
                            <h5>Breakfast in Bed</h5>
                            <p>Start your day right with a delicious breakfast served in the comfort of your room, ensuring a relaxing morning.</p>
                        </div>
                        </div>
                        <div className='location_sec'>
                        <img src={SwimmingIcon}/>
                        <div className='location_content'>
                            <h5>Swimming Pool</h5>
                            <p>Relax and unwind by taking a refreshing dip in our inviting swimming pool, offering a rejuvenating experience. At Best Western, we are proud to work closely with reputable</p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <section className='get_in_touch'>
        <div className='container'>
            <div className='get_touch_sec'>
                <div className='get_touch_content'>
                    <p>At Best Western, we are proud to work closely with reputable associations and organisations that share our vision of world-class travel experiences.</p>
                    <div className='get_text'>
                        <span>Shilparamam Cultural Society</span> <span>2.0 km</span>
                    </div>
                    <div className='get_text'>
                        <span>Golconda Fort</span> <span>5.0 km</span>
                    </div>
                    <div className='get_text'>
                        <span>Birla Mandir</span> <span>5.0 km</span>
                    </div>
                    <div className='get_text'>
                        <span>Chilkur Balaji Temple</span> <span>7.0 km</span>
                    </div>
                    <div className='get_text'>
                        <span>Buddha Statue</span> <span>10.0 km</span>
                    </div>
                    <div className='get_text'>
                        <span>RV Silpa Swimming Pool</span> <span>10.0 km</span>
                    </div>
                </div>
                <div className='get_in_devan'>
                    <div className='get_in_text'>
                        <h5>Devan Hotel</h5>
                        <p>Hyderabad, Telangana</p>
                    </div>
                    <a className='trip_button'>FREE</a>

                </div>
            </div>
            </div> 

      </section>

    
    </>
  )
}
